import Link from 'next/link';
import Image from 'next/future/image';
import { UrlObject } from 'url';
import { useState } from 'react';
import i18n from '@/settings/i18n';
import { priceFormater } from '@/settings/index';
import { priceFormatSuperscript } from '@/lib/price';

const t = i18n.init();
type CollectionItemBoxProps = {
  link: UrlObject;
  image: string;
  title: string;
  price: number;
  fallbackImg?: string;
};

const CollectionItemBox = (props: CollectionItemBoxProps) => {
  const { link, image, title, price, fallbackImg = image } = props;
  const [imageError, setImageError] = useState(false);

  return (
    <div className="mr-[-1px] mb-[-1px] flex flex-col border border-gray-100 bg-white px-2 pt-5 pb-3 xs:px-4 xs:pt-7 xs:pb-3">
      <Link href={link} passHref prefetch={false}>
        <a className="flex h-full w-full flex-col items-center justify-start text-gray-700">
          <div className="relative mt-auto w-full">
            <div>
              {image ? (
                <Image
                  src={imageError ? fallbackImg : image}
                  onError={() => setImageError(true)}
                  alt={title}
                  width="280"
                  height="120"
                  sizes="100vw"
                  loading="lazy"
                  className="h-[18vw] object-contain xs:h-[13vw] sm:h-[10vw] lg:h-[7vw] xl:h-[95px]"
                />
              ) : (
                <div className="h-[18vw] animate-pulse rounded-md bg-gray-700/10 xs:h-[13vw] sm:h-[10vw] lg:h-[7vw] xl:h-[95px]" />
              )}
            </div>
          </div>
          <h4
            // eslint-disable-next-line tailwindcss/no-custom-classname
            className="two-line-ellipsis pt-5 text-center text-xs font-semibold !leading-4 xs:pt-6 sm:text-sm"
          >
            {title}
          </h4>
          <div className="mt-1 text-center text-xs sm:text-sm">
            {t`From`}
            <span className="ml-1">
              {priceFormatSuperscript(priceFormater.long(price.toFixed(2)))}
            </span>
          </div>
        </a>
      </Link>
    </div>
  );
};

export default CollectionItemBox;
